import styled from "styled-components";
import { colors } from '../../styles/colors'
import Fondo2 from "../../styles/Fondo2.png"

export const ContainerContact = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 80px 0 0 0;
    color: ${colors.TEXT_WHITE};
    opacity: 0;
    background-image: url(${Fondo2});
    border-top: solid;
    border-width: 5px;
    border-image: radial-gradient( #ffffff 20%, #181818 85%) 1;

    @keyframes fadeInContact {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }


    @media (max-width: 768px) {
        padding:0;
    }
`

export const TitleResp = styled.h2`
    text-align: center;
    margin-bottom: 30px;
    font-size: 30px;
    background: transparent;
    display: none;

    @media (max-width: 768px) {
        display: flex;
        justify-content: center;
    }
`

export const Title = styled.h2`
    text-align: center;
    margin-bottom: 30px;
    font-size: 30px;
    background: transparent;

    @media (max-width: 768px) {
        display: none;
    }
`

export const ContainerForm = styled.div`
    max-width: 600px;
    border-radius: 10px;
    box-shadow: 0 0 12px rgb(0 0 0 / 16%);
    padding: 30px;
    margin: 50px 0 100px 0;
    border-style: solid;
    border-width: 1.5px;
    border-color: #404040;
    width: 100%;

    p {
        background: transparent;
    }

    @media (max-width: 768px) {
        border-radius: 0;
        box-shadow: none;
        border-style: none;
        background-image: url(${Fondo2});
        text-align: center;
    }
`

export const Form = styled.form`
    box-sizing: border-box;

    @media (max-width: 768px) {
        background: transparent;
    }
`

export const InputForm = styled.input`
    padding: 10px;
    border-radius: 10px;
    border: 2px solid #4c526838;
    background-color: transparent;
    font-size: 16px;
    display: block;
    width: 100%;
    margin-bottom: 15px;
    color: ${colors.TEXT_WHITE};

    @media (max-width: 768px) {
        background: #181818;
    }
`

export const TextArea = styled.textarea`
    padding: 10px;
    border-radius: 6px;
    border: 2px solid #4c526838;
    background-color: transparent;
    font-size: 16px;
    display: block;
    width: 100%;
    height: 200px;
    margin-bottom: 15px;
    color: ${colors.TEXT_WHITE};

    @media (max-width: 768px) {
        background: #181818;
    }
`
export const Button = styled.button`
    color: ${colors.TEXT_WHITE};
    /* box-shadow: ${colors.BOX_SHADOW_WHITE}; */
    background: #61bdfb;
    padding: 10px 40px;
    border-radius: 999px;
    border: none;
    margin: 15px 0;
    font-weight: 700;
    cursor: pointer;
    width: 150px;
    text-transform: uppercase;
`

export const ContainerCondition = styled.div`
    display: flex;
    justify-content: start;
    align-items: center;
    span{
        color: ${colors.TEXT_WHITE};
        font-size: 15px;
        margin: 0 10px;
    }
    
    @media (max-width: 768px) {
        background: transparent;
        justify-content: center;
        span {
            background: transparent;            
        }
    }
`

export const TextError = styled.p`
    color: red;
    font-size: 15px;
`

export const SuccessMessage = styled.p`
    color: green;
    font-size: 15px;
`


export const Footer = styled.footer`
    color: white;
    font-size: 15px;
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-around;

    img {
        width: 40px;
    }

    @media (max-width: 768px) {

        flex-direction: column;
        padding: 10px 0;

        img {
            width: 20px;
        }

        p {
            font-size: xx-small;
        }
    }
`

export const WhatSapp = styled.div`
    display: flex;
    align-items: center;
    p {
        margin: 0 5px;
    }
`

export const Correo = styled.div`
    display: flex;
    align-items: center;
    p {
        margin: 0 5px;
    }
`

export const Direcc = styled.div`
    display: flex;
    align-items: center;
    p {
        margin: 0 5px;
    }
`